module.exports = __webpack_public_path__ + "static/tickets_dashboard-0e3da9288635c20a910c38c4183905f5.png";